import Ajax from '../../../midflip_phx/deps/phoenix/assets/js/phoenix/ajax'

export default {
	unitName: "PricingTable",
	onConnected(){
		if(midflip.pricingTableLoaded == true){return}
		midflip.pricingTableLoaded = true
		console.log("AAA")
		fetch('https://js.stripe.com/v3/pricing-table.js', {method: 'GET'}).then((resp)=>{
			resp.text().then((code) => {
				console.log(code)
				window.eval(code)
			})
		})
		console.log("BBB")
	}
}